import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const clone: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M13 .75v-8.5a.22.22 0 0 0-.078-.172A.22.22 0 0 0 12.75-8h-8.5a.24.24 0 0 0-.172.078A.2.2 0 0 0 4-7.75v8.5c0 .07.023.129.078.172.05.05.11.078.172.078h8.5q.106 0 .172-.078A.22.22 0 0 0 13 .75m1-8.5v8.5q0 .514-.375.875A1.17 1.17 0 0 1 12.75 2h-8.5q-.515 0-.89-.375A1.19 1.19 0 0 1 3 .75v-8.5c0-.344.117-.633.36-.875Q3.734-9 4.25-9h8.5q.514 0 .875.375.375.361.375.875m-3-3v1.25h-1v-1.25a.22.22 0 0 0-.078-.172A.22.22 0 0 0 9.75-11h-8.5a.24.24 0 0 0-.172.078.2.2 0 0 0-.078.172v8.5c0 .063.023.121.078.172.05.055.11.078.172.078H2.5v1H1.25c-.344 0-.64-.117-.89-.36A1.23 1.23 0 0 1 0-2.25v-8.5c0-.344.117-.633.36-.875Q.734-12 1.25-12h8.5c.344 0 .633.125.875.375q.375.361.375.875m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "14",
    width: "14",
  }
};